const Module = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "icon": 'Icon',
    "status": "Status",
    "priority": "Priority",
    "search": "Search",

    // PAGE HEADER
    "module": "Module",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_status": "Select Status",
    "error_priority_positive": "Priority Should be Positive",
    "error_priority_required": "Enter Priority",
    "error_priority_type_error": "Enter only Number",
    "error_icon": "Enter Icon Name",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_priority": "PRIORITY",
    "table_status": "STATUS",

}

export default Module;